// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1856e61f","455":"6b703cde","977":"faf29ae3"}[chunkId] + ".chunk.js";
};